import React, { useEffect, useRef, useState } from 'react';
import {
  ShowActivityForm,
  ShowBeachForm,
  updateUsageRating,
} from '../utils/helpers/view/usageNoteHelper';
import { formType } from '../utils/Interface';
import { LocalStorage } from '../utils/localStorage';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import Form from 'saur_ui_library/src/Atoms/Input/Form/Form';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { createGlobalStyle } from 'styled-components';
import { UsageRatingApi } from '../utils/api';
import { Toast } from 'primereact/toast';
import SaveButton from '../components/common/SaveButton';
import { getParameters, handleOnSubmit } from '../utils/helpers/apiHelper';
import { loaderDataComponent } from '../utils/helper';

const UsageNote = ({ coastline }) => {
  const [dataList, setDataList] = React.useState<any>();
  const [form, setForm] = React.useState<formType>({
    id: dataList?.id,
    rating: dataList?.rating,
    beachLengthCode: dataList?.beachLengthCode,
    nearbyBeach: dataList?.nearbyBeach,
    nearbyShellfishArea: dataList?.nearbyShellfishArea,
    beachSupervised: dataList?.beachSupervised,
    shellfishAreaSurfaceCode: dataList?.shellfishAreaSurfaceCode,
    mainInstallCode: dataList?.mainInstallCode,
    nearbyFishingArea: dataList?.nearbyFishingArea,
    nearbySaltMarsh: dataList?.nearbySaltMarsh,
    nearbyMooring: dataList?.nearbyMooring,
    nearbyWaterActivitiesCenter: dataList?.nearbyWaterActivitiesCenter,
    nearbyDrinkingWaterCatchmentArea:
      dataList?.nearbyDrinkingWaterCatchmentArea,
    fishCategoryCode: dataList?.fishCategoryCode,
  });
  const [loading, setLoading] = React.useState(false);
  const [grayedBeach, setGrayedBeach] = React.useState(false);
  const [grayedActivity, setGrayedActivity] = React.useState(false);
  const [, setParamName] = useState('');
  const [code, setCode] = useState(window.sessionStorage.getItem('Code'));
  const [rating, setRating] = useState();

  const toastSucess = useRef<any>(null);
  const toastError = useRef<any>(null);

  //useEffects
  useEffect(() => {
    const localName = LocalStorage.prName.get();
    if (localName !== null) {
      setParamName(localName.toString());
    }
    setCode(window.sessionStorage.getItem('Code'));
    getParameters(setLoading, setDataList, UsageRatingApi.getUsageRating(code));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //useEffects
  useEffect(() => {
    const notAllowedKeys = ['mainInstallCode', 'rating'];
    let newDataList = { ...dataList };
    if (newDataList) {
      Object.keys(newDataList).forEach((key) => {
        if (notAllowedKeys.includes(key)) delete newDataList[key];
      });
    }
    setRating(dataList?.rating);
    if (coastline && newDataList?.id) {
      // function to update form avd rating if coastline checked
      updateUsageRating(
        setRating,
        newDataList,
        code,
      );
    }
    setForm(newDataList);
    setGrayedBeach(newDataList?.nearbyBeach);
    setGrayedActivity(newDataList?.nearbyShellfishArea);
  }, [dataList]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Card className='note-container'>
      <Styles />
      <Toast id='toast-success' ref={toastSucess} />
      <Toast id='toast-error' ref={toastError} />
      <Container className='global-card-container'>
        <Form
          onSubmit={() => {
            let newForm = { ...form };
            if (!form.nearbyBeach && form.nearbyShellfishArea) {
              newForm.beachLengthCode = 1;
              newForm.beachSupervised = false;
            } else if (form.nearbyBeach && !form.nearbyShellfishArea) {
              newForm.shellfishAreaSurfaceCode = 1;
            } else if (!form.nearbyBeach && !form.nearbyShellfishArea) {
              newForm.beachLengthCode = 1;
              newForm.beachSupervised = false;
              newForm.shellfishAreaSurfaceCode = 1;
            }
            handleOnSubmit(
              setLoading,
              UsageRatingApi.updateUsageRating(newForm, code),
              toastSucess,
              toastError,
              setDataList,
            );
          }}
        >
          <ShowBeachForm
            form={form}
            setForm={setForm}
            setGrayedBeach={setGrayedBeach}
            grayedBeach={grayedBeach}
          />
          <Container className='second-container'>
            <ShowActivityForm
              form={form}
              setForm={setForm}
              setGrayedActivity={setGrayedActivity}
              grayedActivity={grayedActivity}
              coastline={coastline}
            />
          </Container>
          <Container className='rectangle'>
            <Word
              className='note-style'
              variant='span'
              textStyle='normalBold'
              value={`Note: ${rating || 0} / ${
                rating! <= 360 ? '360' : '430'
              }`}
            />
          </Container>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {loaderDataComponent(loading, ` width: 28px;
              height: 28px;
              border: 5px solid #FFF;
              border-bottom-color: #243977;
              border-radius: 50%;
              display: inline-block;
              box-sizing: border-box;
              animation: rotation 1s linear infinite;`)}
          </div>
          {loading === false && <SaveButton />}
        </Form>
      </Container>
    </Card>
  );
}

const Styles = createGlobalStyle`
.sds-reset-style{
  .note-container{
    display: flex;
    justify-content: center;
    align-items: center; 
    .global-card-container{
      width: 800px;
      .grayed-out {
        opacity: 0.5;
        pointer-events: none;
      }    
      .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
        background: #76D19B !important;
    }
    .p-inputswitch{
    width: 48px;
    height: 28px;
   .p-inputswitch-slider:before {
    width: 20px;
    height: 20px;
    left: 4px;
    margin-top: -10px;
    }
  }

  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
    -webkit-transform: translateX(18px);
    transform: translateX(18px);
  }
  
  .rectangle {
    background-color: #FFE0B3;
    border-radius: 15px;
    width: 236px;
    height: 97px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
    
    .note-style {
      color: #333;
      color: #232323;
      font-size: 20px;
      line-height: 24px;
      text-align: left;
    }
    }
    .card-data{
      box-shadow: none;
    }
    .beach-switch, .activity-switch, .radio-list{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 16px;
      .word-className{
        margin-left: 40px;
      }
      .radio-item{
        margin-bottom: 0px;
        margin-left: 18px;
        .sds-radio-custom-element-item.active {
          width: 7px;
          height: 7px;
       }
      }
     }
     .radio-list {
      margin-bottom: 5px !important;
     }
    }
    .styledSectionButton{
      flex-direction: row;
      justify-content: space-around;
      .save-btn{
       margin: 20px auto;
     }
   }
  }
`;

export default React.memo(UsageNote);
